import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Paging from "../../../../Components/Paging";
import TablePlaceHolder from "../../../../Components/TablePlaceHolder";
import Handler from '../../../../Helpers/Handler'
import { FaEye, FaTools } from "react-icons/fa";
import Register from './Register'
import useListParams from "../../../../Helpers/useListParams";

const Index = () => {
    const [register, setRegister] = useState(false)
    const { id } = useParams()
    const [search, setSearch] = useState("")
    const [service, setServiceList] = useState([])
    // Page number in the query (?svcPage=2) so Back from a service record returns to it - see Helpers/useListParams.
    const { page: pageNo, setPage: setPageNo } = useListParams({}, { query: true, prefix: "svc" })
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    const getServiceList = async () => {
        setLoading(false)
        const data = { ...(search && search?.trim() !== "" ? { value: search } : {}), }
        const response = await Handler({ method: 'POST', url: `/admin/car/service/list/${id}?page=${Number(pageNo) - 1}&count=10`, data })
        if (response?.success) {
            const decryptedData = (response?.data)?.data
            setServiceList(decryptedData?.list)
            setNext(decryptedData?.next)
        } else {
            setServiceList([])
            setNext(false)
        }
        setLoading(true)
    }
    useEffect(() => {
        getServiceList()
    }, [search, pageNo])
    return (
        <React.Fragment>
            {register && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation</h5>
                                <button className="btn-close" onClick={() => setRegister(false)}></button>
                            </div>
                            <div className="modal-body">
                                <Register />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {register && <div className="modal-backdrop fade show"></div>}

            <div className="card border-0 shadow-sm rounded-4 my-4">
                <div className="card-body">
                    <div className="d-sm-flex justify-content-between mb-2">
                        <h5 className="fw-semibold d-flex align-items-center justify-content-sm-start justify-content-center mb-sm-0 mb-2 gap-2"> <FaTools /> Service Details</h5>
                    </div>
                    <hr className="m-0 my-3" />
                    <div className=' justify-content-end align-items-center row' >
                        {/* <div md={3} className="col-md-3"><input autoComplete='off' className='search-box form-control p-1 border-0 border-bottom rounded-0' placeholder='Search...' value={search} onChange={(e) => setSearch(e.target.value)} /></div> */}
                        <div className="my-3 my-md-0 d-flex justify-content-md-end justify-content-center col-md-3"><button className='btn btn-primary' onClick={() => setRegister(true)} >Add Service</button></div>
                    </div>
                    <div className="overflow my-3">
                        <table className="table-bg w-100" borderless="true" >
                            <thead>
                                <tr className="border-bottom" >
                                    <th className="p-1">Service Id</th>
                                    <th className="p-1">Service Name</th>
                                    <th className="p-1">Service Type </th>
                                    <th className="p-1"> Status </th>
                                    <th className="p-1 text-center"> Action </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    loading ?
                                        service && service?.length !== 0 ? service?.map((value, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td className="p-1">{(value?.serviceId)}</td>
                                                    <td className="p-1 text-capitalize">{(value?.serviceName)}</td>
                                                    <td className="p-1">{value?.serviceType}</td>
                                                    <td className="p-1">{value?.serviceStatus}</td>
                                                    <td className="p-1 text-center"><button className="btn p-0" onClick={() => navigate(`/vehicle-fleet/services/${value?.serviceId}`)}><FaEye className="fs-5" /> </button></td>
                                                </tr>
                                            )
                                        }) :
                                            <tr className='text-center' ><td colSpan={9} className="p-1">No Data Found</td></tr>
                                        : <TablePlaceHolder count={5} />
                                }
                            </tbody>
                        </table>
                    </div>
                    <Paging previousValue={pageNo > 1} current={pageNo} onPageChange={setPageNo} nextValue={next} />
                </div>
            </div>
        </React.Fragment>
    )
}

export default Index;